<template>
  <v-main>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="mt-n3">{{$t("Pre-registrations")}}</h1>
        </v-flex>

        <v-flex xs12 class="mb-4">
          <v-layout row wrap>
          <v-btn v-if="this.showNewBtn" class="ml-1 mr-4 mt-4" :to="{name: 'create-pre-registration-registration', params: {id: null}}" color="primary">
            <v-icon left>add</v-icon>
            {{$t("New")}}
          </v-btn>
          <v-flex grow></v-flex>
          <v-flex shrink><v-select class="ml-2" hide-details="true" :items="facilitiesDisplay" v-model="facilityDisplay" @change="facilityChanged" :label="$t('Facility')"></v-select></v-flex>
          </v-layout>
        </v-flex>

        <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
        <v-flex xs12 v-else>
          <div v-if="registrations != null && registrations.length == 0" class="mt-4" style="text-align: center">{{$t("No unfinished registrations found")}}</div>
          <template v-else v-for="preReg in orderedRegistrations">
            <div v-if="preReg.FinishedBy == null && !preReg.Completed && (preReg.PreStatus == 1 || preReg.PreStatus == 3 || preReg.PreStatus == 4)" :key="preReg.id">
              <ActivePreRegistration :preReg="preReg"/>
            </div>
          </template>

        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <div v-if="loading"></div>
        <v-flex xs12 v-else>
          <h2 class="mb-4 mt-4">{{$t("Recent Registrations")}}</h2>
        </v-flex>

        <div v-if="loading"></div>
        <v-flex xs12 v-else>
          <div v-if="registrations != null && registrations.length == 0" class="mt-4" style="text-align: center">{{$t("No recent registrations found")}}</div>
          <div v-else v-for="preReg in orderedRegistrationsReverse" :key="preReg.id">
            <div v-if="preReg.FinishedBy != null || preReg.Completed && !(preReg.PreStatus == 1 || preReg.PreStatus == 3 || preReg.PreStatus == 4)">
              <ExpiredPreRegistration :preReg="preReg"/>
            </div>
          </div>

        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { app } from '@/main'
import filters from '@/core/mixins/common-filters'
import * as DateUtil from '@/core/date'
import * as PreRegistration from '@/modules/pre-registration/pre-registration'
import * as Archive from '@/core/archive'
import * as LocalStorage from '@/core/local-storage'
import * as turf from '@turf/turf'
import ActivePreRegistration from '@/modules/pre-registration/views/ActivePreRegistration'
import ExpiredPreRegistration from '@/modules/pre-registration/views/ExpiredPreRegistration'
import * as Security from '@/core/security'
import _ from 'lodash' // clone

export default {
  mixins: [filters],
  name: 'registrations',
  components: { ActivePreRegistration, ExpiredPreRegistration },
  data () {
    return {
      loading: true,
      registrations: null,
      loadRegistrationsIntervalId: null,
      getGPSIntervalId: null,
      distance: 0,
      facilityNo: null,
      facilities: null,
      facilitiesDescription: [],
      facilityDescription: '',
      useFacilityDescription: false,
      facilityDisplay: '',
      facilitiesDisplay: [],
      userVehicleLicensePlateNo: null,
      showNewBtn: false,
      returnTo: 'pre-registration-registrations',
      gpsTargetPosition: [0, 0]
    }
  },
  watch: {
    $route: {
      handler () {
        if (this.$route.path.includes('arrival')) {
        }
      }
    }
  },
  methods: {
    printRegistration (regId) {
      PreRegistration.printRegistration(regId)
      this.$root.$message.showSuccess(this.$t('Confirmation printed'))
    },
    getHeaderValue (item, header) {
      let result = ''
      if (!Object.prototype.hasOwnProperty.call(header, 'Source') || (header.Source === 'WeightRegistration' || header.Source == null)) {
        result = item.WeightRegistration[header.Field]
      } else {
        if (header.Source === 'PreRegistrationRegistration') {
          result = item[header.Field]
        }
      }
      if (header.AsDate) result = DateUtil.getDateTime(result)
      return result
    },
    getHeaderStyle (header) {
      let result = ''
      if (Object.prototype.hasOwnProperty.call(header, 'Style')) {
        result = header.Style
      }
      return result
    },
    async loadFacilityDetails () {
      const res = await PreRegistration.loadFacilityData({ facilityNo: this.facilityNo, corpName: Security.user.corporation })
      if (!res.failed && res.data !== null) {
        this.details = res.data.Details
        /* const preRegistrationGPSAcceptedDistanceKmDetail = this.details.find(o => o.Name === 'PreRegistration_GPSAcceptedDistanceKm')
        if (preRegistrationGPSAcceptedDistanceKmDetail !== undefined) {
          this.localPrint = preRegistrationGPSAcceptedDistanceKmDetail.Value
        } */
        const preRegistrationGPSPositionDetail = this.details.find(o => o.Name === 'PreRegistration_GPSPosition')
        if (preRegistrationGPSPositionDetail !== undefined) {
          this.gpsTargetPosition = preRegistrationGPSPositionDetail.Value.split(',').reverse()
          console.log('Facility Target GPS: ', this.gpsTargetPosition, preRegistrationGPSPositionDetail)
        }
      }
    },
    async facilityChanged () {
      if (this.useFacilityDescription) {
        var facilityDisplay = this.facilitiesDisplay.find(f => f.value === this.facilityDisplay)
        if (facilityDisplay != null) {
          this.facilityNo = facilityDisplay.item.No
        }
      } else {
        this.facilityNo = this.facilityDisplay
      }

      if (this.facilityNo != null) LocalStorage.save('facilityNo', this.facilityNo)
      this.registrations = null
      const res = await PreRegistration.loadRegistrations(this.facilityNo)
      if (!res.failed) {
        this.registrations = res.data
        this.showNewBtn = this.showNewBtnCheck()
        // load user. Pre-Registration GPS settings
        await this.loadFacilityDetails()
      }
    },
    showNewBtnCheck () {
      // Only show New button if no userVehicleLicensePlateNo or if all regs are finished
      return !this.userVehicleLicensePlateNo || (this.userVehicleLicensePlateNo && this.registrations.every(r => r.FinishedDate))
    },
    async getGpsPosition () {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          (p, e, o) => { resolve([p.coords.longitude, p.coords.latitude]) }, reject, { enableHighAccuracy: true })
      })
    },
    getDistance (gpsPosition) {
      // Distance to Scanvaegt Systems Johann Gutenbergs Vej 5-9, 8200 Aarhus (longitude,latitude) [10.185716, 56.205002]
      // Use http://www.movable-type.co.uk/scripts/latlong.html for distance check
      // between Point 1 and 2 (Note: latitude, longitude also in Google Maps coordinates, but opposite in turf)

      const from = turf.point(gpsPosition) // Current GPS "fugleflugt" distance to Scanvaegt Systems
      const to = turf.point(this.gpsTargetPosition) // Scanvaegt Systems Johann Gutenbergs Vej 5-9
      const distance = turf.distance(from, to)

      console.log('Current GPS: ', gpsPosition.reverse().toString())

      return Math.round(distance * 100) / 100
    }
  },
  computed: {
    orderedRegistrations: function () {
      var self = this // Need this to refence this.newestFirst inside compare function.
      var sortComparer = function (a, b) {
        // if a is less than b, return -1
        // if a is greater than b, return 1
        // if a is equal to b, return 0
        var aDate = new Date(a.CreatedDate)
        var bDate = new Date(b.CreatedDate)
        /* if(self.newestFirst)
          return bDate - aDate;
        else */
        return aDate - bDate
      }
      if (self.registrations) {
        return self.registrations.sort(sortComparer)
      } else {
        return []
      }
    },
    orderedRegistrationsReverse: function () {
      return this.orderedRegistrations.slice().reverse()
    }
  },
  beforeDestroy () {
    // Stop fetching GPS coordinates
    if (this.getGPSIntervalId) clearInterval(this.getGPSIntervalId)
    // Stop update of registration list
    clearInterval(this.loadRegistrationsIntervalId)
  },
  async mounted () {
    // load Users VehicleLicensePlateNo - if any - and filter/fix the Vehicles drop down field. If no VehicleLicensePlateNo show all Vehicles.
    const userRes = await PreRegistration.userVehicleLicensePlateNo()
    if (!userRes.failed) {
      this.userVehicleLicensePlateNo = userRes.data.userVehicleLicensePlateNo
    }
    var noValue = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === undefined ?? false
    if (noValue) {
      this.useFacilityDescription = false
    } else {
      this.useFacilityDescription = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === 'true' ?? false
    }

    // Update distance every 4 seconds - only for users with VehicleLicensePlateNo setup (ie. Vehicle drivers, not admin user or WheelLoader users)
    if (this.userVehicleLicensePlateNo) {
      this.getGPSIntervalId = setInterval(async () => {
        const gpsPosition = await this.getGpsPosition()
        const distanceNow = this.getDistance(gpsPosition)

        // Fire distance event to ActivePreRegistration
        this.$root.$emit('distance', distanceNow)
        console.log('Distance: ', distanceNow + ' km')
      }, 4000)
    }

    // Load corp. Pre-Registration GPS settings
    const gpsLatitudeLongitudeArray = (Security.user.corporationDetails.find(d => d.Name === 'PreRegistration_GPSPosition')?.Data1 ?? '56.2050473652695,10.185711838787292').split(',')
    console.log('Target GPS: ', gpsLatitudeLongitudeArray.toString())
    this.gpsTargetPosition = gpsLatitudeLongitudeArray.reverse() // switch Latitude,Longitude to Longitude,Latitude for turf usage

    // Update registration list every 5 seconds
    this.loadRegistrationsIntervalId = setInterval(async () => {
      const res = await PreRegistration.loadRegistrations(this.facilityNo)
      if (!res.failed) {
        this.registrations = res.data
        this.showNewBtn = this.showNewBtnCheck()
      }
    }, 5000)

    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })

    const facilitiesRes = await Archive.loadFacilities()
    const facilitiesResDescription = _.cloneDeep(facilitiesRes)
    if (!facilitiesRes.failed) {
      // Let user select no facilities (= show data from all allowed facilities)
      if (!facilitiesRes.data.includes('')) facilitiesRes.data.unshift({ No: '', Name: '' })
      this.facilities = facilitiesRes.data.map(item => {
        return {
          text: item.No,
          value: item.No,
          item: item
        }
      })
      this.facilitiesDisplay = this.facilities
      if (this.useFacilityDescription) {
      // const facilitiesRes2 = await Archive.loadFacilities()
        var d = facilitiesResDescription.data
        if (!d.includes('')) d.unshift({ No: '', Description: '' })
        this.facilitiesDescription = d.map(item => {
          return {
            text: item.Description,
            value: item.Description,
            item: item
          }
        })

        this.facilitiesDisplay = this.facilitiesDescription
      }
    }

    const storedFacilityNo = '' + LocalStorage.load('facilityNo')
    if (storedFacilityNo && this.facilities.some(e => e.item.No === storedFacilityNo)) this.facilityNo = storedFacilityNo
    else {
      this.facilityNo = null
      LocalStorage.remove('facilityNo')
    }

    if (this.useFacilityDescription) {
      if (this.facilityNo == null) { this.facilityNo = '' }
      this.facilityDisplay = this.facilitiesDescription.find(f => f.item.No === this.facilityNo).value
    } else {
      if (this.facilityNo == null) { this.facilityNo = '' }
      this.facilityDisplay = this.facilities.find(f => f.item.No === this.facilityNo).value
    }

    // load user. Pre-Registration GPS settings
    await this.loadFacilityDetails()

    const res = await PreRegistration.loadRegistrations(this.facilityNo)
    this.loading = false
    if (!res.failed) {
      this.registrations = res.data
      this.showNewBtn = this.showNewBtnCheck()
    }
  }
}
</script>

<style>

</style>
